import TemplateView from '../../../TemplateView'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import PageContent from './PageContent'
import LoadingContainer from '../../../util/LoadingContainer'
import {geSelectedYear, isFirstLoading, isLoading} from '../selectors'
import {loadData} from '../actions'

class Page extends TemplateView {
    constructor({
        loadData
    }) {
        super()

        this.actions = {
            loadData
        }

        this.state = {
            firstLoading: false,
            loading: false,
            selectedYear: '',
        }

        this.onStatePropertyChanged('loading', (loading)=> {
            this.loadingContainer.setState({loading: loading})
        })

        this.onStatePropertyChanged("firstLoading", (firstLoading, prevFirstLoading) => {
            this.loadingContainer.setState({loading: firstLoading})

            if(firstLoading !== prevFirstLoading && firstLoading === true) {
                this.actions.loadData(this.state.selectedYear)
            }
        })
    }

    templateHtml() {
        return '<div class="page"\>'
    }

    afterRender() {
        this.contentComponent = new PageContent();
        this.loadingContainer = new LoadingContainer({
            contentComponent: [this.contentComponent],
            containerClass: 'calendarPageLoadingContainer',
            loadingMoireConfig: {
                additionalSpinnerSettings: {
                    radius: 16
                },
            },
            showAnimated: false,
            proxySetState: false
        }).init(this.getEl())
    }
}

export default connect(
    (state) => ({
        firstLoading: isFirstLoading(state),
        loading: isLoading(state),
        selectedYear: geSelectedYear(state)
    }),
    (dispatch) => ({
        loadData: bindActionCreators(loadData, dispatch),
    })
)(Page)


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/CalendarPage.js